'use client';
import { useState } from 'react';
import { DialogTrigger } from '@radix-ui/react-dialog';
import { useCart } from '@/frontastic';
import { combinedKeyPressHandler, getAgentName } from '@/helpers/utils/siteUtils';
import { ADDITIONAL_DETAILS_NAME, ADDITIONAL_DETAILS_TYPE } from '../../../../../constants/constant';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import Loader from '../../ui/loader';
import { Textarea } from '../../ui/textarea';

const HoldOrderModal = ({
  Texts,
  holdOrder,
  setHoldSuccessMsg,
}: {
  Texts: any;
  holdOrder?: any;
  setHoldSuccessMsg?: any;
}) => {
  const [open, setOpen] = useState(false);
  const { freezeCart, addAdditionalDetails } = useCart(false);
  const [notes, setNotes] = useState('');
  const [error, setError] = useState({ state: false, message: '' });
  const [loading, setLoading] = useState(false);

  const handleFreezeCart = async () => {
    if (!notes) {
      return setError({ state: true, message: Texts.enterNote });
    }
    if (holdOrder) {
      setLoading(true);
      await holdOrder(notes); // Post Submission Hold Order i.e. [Order details page]
    } else {
      const notesPayload = {
        name: ADDITIONAL_DETAILS_NAME.HOLD_ORDER,
        value: notes,
        type: ADDITIONAL_DETAILS_TYPE.NOTES,
        agentName: getAgentName()?.replace(/@.*/, ''),
      };

      await freezeCart(); // commercetools hold order [cart / checkout]
      setHoldSuccessMsg(true);
      setTimeout(() => {
        setHoldSuccessMsg(false);
      }, 5000);
      await addAdditionalDetails(notesPayload);
    }
    setLoading(false);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
        setNotes('');
      }}
    >
      <DialogTrigger className="text-[#0075C9] underline">{Texts.holdOrder}</DialogTrigger>
      <DialogContent className="max-w-[667px] bg-white sm:rounded-md">
        {loading && <Loader />}
        <DialogHeader>
          {/* chng-text-25px */}
          <DialogTitle className="text-2xl font-bold">
            <section>
              <div className="text-2xl font-bold">{Texts.holdOrder}</div>
              <div className="text-xs font-normal">*{Texts.requiredFields}</div>
            </section>
          </DialogTitle>
        </DialogHeader>
        <section>
          <section className="h-[114px]">
            <Textarea
              placeholder="*Note"
              className={`h-full w-full resize-none ${error?.state ? 'border-scarletRed' : 'border-foggyGray'}`}
              value={notes}
              onChange={(e) => {
                setNotes(e.target.value);
                setError({ state: false, message: '' });
              }}
              maxLength={2500}
              onKeyPress={combinedKeyPressHandler}
            />
          </section>
          {error?.state ? <section className="font-semibold text-scarletRed">{error?.message}</section> : <></>}
        </section>

        <section className="flex justify-start gap-4">
          <Button className="rounded-md bg-deepBlue p-4 text-white" onClick={handleFreezeCart}>
            {Texts.holdOrder}
          </Button>
          <Button className="p-0 underline" onClick={() => setOpen(false)}>
            {Texts.cancel}
          </Button>
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default HoldOrderModal;
